/**
 * NiV Clinic Detail — "לני" tab (support chat history).
 */

import { Robot } from "@phosphor-icons/react";
import LennyHistory from "../../shared/LennyHistory";

export default function LennyTab({ clinicId }) {
  return (
    <section className="ncd2-card">
      <header className="ncd2-card-head">
        <span className="ncd2-card-icon">
          <Robot size={15} weight="bold" />
        </span>
        <div className="ncd2-card-titles">
          <span className="ncd2-card-eyebrow">תמיכה</span>
          <h3 className="ncd2-card-title">שיחות עם לני</h3>
        </div>
      </header>
      <LennyHistory clinicId={clinicId} />
    </section>
  );
}
